import styled from 'styled-components';

import { Box } from 'components/Box/Box';
import { colors, cssBreakpoints, transition } from 'theme/theme';

export const AmpPageHeaderBox = styled(Box)`
  z-index: 101;
  height: 72px;
  font-size: 15px;
  line-height: normal;

  @media screen and (max-width: ${cssBreakpoints.mdDown}) {
    height: 60px;
  }

  @media screen and (min-width: ${cssBreakpoints.mdUp}) {
    height: 72px;
  }
`;

export const AmpPageHeaderNavLinksBox = styled(Box)<{ $menuOpen?: boolean }>`
  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    visibility: ${(props) => (props.$menuOpen ? 'visible' : 'hidden')};
    position: fixed;
    bottom: 100%;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    max-width: 100%;
    overflow-y: scroll;
    background: white;

    box-shadow: -2px 0 4px rgba(0, 0, 0, 0.1);
    transition:
      transform ${transition},
      visibility ${transition};
    will-change: transform;
    ${(props) =>
      props.$menuOpen
        ? `
      transform: translateY(100%);
    `
        : `
      transform: translateY(-6px);
    `}
  }
`;

export const AmpPageHeaderSeparator = styled.div`
  width: 1px;
  height: 20px;
  background: ${colors.elementGrey};
  opacity: 0.5;
`;

export const AmpPageHeaderLoginLink = styled.a`
  color: ${colors.mediumContentGrey};
  font-size: inherit;
  transition: color ${transition};
  &,
  &:hover,
  &:focus {
    text-decoration: none;
  }
  &:hover,
  &:focus {
    color: ${colors.brandBlue};
  }
`;
